/**
 * Historical public routes retained at the runtime boundary.
 *
 * Content generation remains canonical: these aliases are applied consistently
 * by both the client router and the Worker request resolver.
 */
const runtimeRouteAliases: Readonly<Record<string, string>> = {
  '/guide/nulloplasty': '/English/Nulloplasty',
  '/procedures/nulloplasty': '/English/Nulloplasty',
};

const runtimePageIds: Readonly<Record<string, string>> = {
  '/explore': 'explorer-en',
  '/compare': 'compare-en',
  '/stories': 'collection-stories-en',
  '/tools': 'collection-tools-en',
};

export function resolveRuntimeRoute(route: string): string {
  return runtimeRouteAliases[route] ?? route;
}

export function runtimePageIdForRoute(route: string): string | undefined {
  return runtimePageIds[route];
}
